import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  API_BASE_URL,
  API_AUTH_USERNAME,
  API_AUTH_PASSWORD,
} from "../../Constant/Global";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const handleInputOnchange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  useEffect(()=>{
    if(sessionStorage.getItem("info") !== null){
       navigate( "/admin");
    }
  },[])

  const handleValidation = () => {
    let valid = true;
    // Email format validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (formData.email === "") {
      toast.error("Email Is Require");
      valid = false;
    } else if (!emailRegex.test(formData.email)) {
      toast.error("Invalid email format");
      valid = false;
    } else if (formData.password === "") {
      toast.error("Password Is Require");
      valid = false;
    }
    return valid;
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!handleValidation()) {
      return;
    }
    const { email, password } = formData;
    try {
      const finalData = {
        user_email: email,
        password: password,
      };
      console.log("finalData", finalData);
      const response = await axios.post(
        API_BASE_URL + "api/admin/login",
        finalData,
        {
          auth: {
            username: API_AUTH_USERNAME,
            password: API_AUTH_PASSWORD,
          },
        }
      );
      console.log("login response", response.data);
      if (response.data.status === true) {
        sessionStorage.setItem("info", JSON.stringify(response.data.data));
        sessionStorage.setItem("info", JSON.stringify({...response.data.data, user_type: "admin"}));
        navigate("/admin");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.log(error.response.data.message);
    }
  };

  return (
    <>
      <div className="position-relative overflow-hidden radial-gradient min-vh-100 d-flex align-items-center justify-content-center">
        <div className="d-flex align-items-center justify-content-center w-100">
          <div className="row justify-content-center w-100">
            <div className="col-md-8 col-lg-6 col-xl-4 col-xxl-3">
              <div className="card mb-0">
                <div className="card-body">
                  <Link
                    to="/login"
                    className="text-nowrap logo-img text-center d-block mb-5 w-100"
                  >
                    {/* <img
                      src={darkLogo}
                      width="180"
                      alt=""
                    /> */}
                    <h3>
                      <b>ADMIN LOGIN</b>
                    </h3>
                  </Link>
                  <form onSubmit={handleLogin}>
                    <div className="mb-3">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        Email
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputOnchange}
                        className="form-control"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                      />
                    </div>
                    <div className="mb-4">
                      <label
                        htmlFor="exampleInputPassword1"
                        className="form-label"
                      >
                        Password
                      </label>
                      <input
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleInputOnchange}
                        className="form-control"
                        id="exampleInputPassword1"
                      />
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-4">
                      <div className="form-check">
                        <input
                          className="form-check-input primary"
                          type="checkbox"
                          value=""
                          id="flexCheckChecked"
                          defaultChecked
                        />
                        <label
                          className="form-check-label text-dark"
                          htmlFor="flexCheckChecked"
                        >
                          Remember this Device
                        </label>
                      </div>
                      <Link
                        className="text-primary fw-medium"
                        to={`/forget-password/${"admin"}`}
                      >
                        Forgot Password ?
                      </Link>
                    </div>
                    <button
                      type="submit"
                      className="btn btn-primary w-100 py-8 rounded-2"
                    >
                      Sign In
                    </button>
                    <Link
                      to="/employee_login"
                      className="d-flex justify-content-end"
                      style={{ textDecoration: "underline" }}
                    >
                      Login With Employee
                    </Link>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer
          position={"top-right"}
          autoClose={2000}
          pauseOnHover={false}
          closeOnClick={true}
        />
      </div>
    </>
  );
};

export default Login;
